import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#58E2C2',
                primaryShade1: 'rgba(90, 226, 194, 0.302)',
                secondary: '#1B2342',
                inProgress: '#FFC1074D',
                red: '#EC5C56',
                white: '#FFF',
                secondaryBackground: '#E5E5E5',
            },
            dark: {
                primary: '#58E2C2',
                primaryShade1: 'rgba(90, 226, 194, 0.302)',
                secondary: '#1B2342',
                inProgress: '#FFC1074D',
                red: '#EC5C56',
                white: '#FFF',
                secondaryBackground: '#E5E5E5',
            }
        }
    }
});
